import { render, staticRenderFns } from "./PublishToPlatformModal.vue?vue&type=template&id=1bbeedae&scoped=true"
import script from "./PublishToPlatformModal.vue?vue&type=script&lang=js"
export * from "./PublishToPlatformModal.vue?vue&type=script&lang=js"
import style0 from "./PublishToPlatformModal.vue?vue&type=style&index=0&id=1bbeedae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bbeedae",
  null
  
)

export default component.exports